import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableString } from '../utils/wire-value-utils';

/**
 * A product label PDF on a chemical (hub `epa_chemical_labels`), as `/admin/chemicals/:id` and
 * `/admin/epa-chemicals/:id` return it in `labels`. Labels are added and removed through their own routes,
 * never sent back as a body. Unsent fields stay `undefined`.
 */
export class ChemicalLabel extends Base {
  chemicalId?: string | null;
  labelUrl?: string | null;
  labelName?: string | null;
  /** ISO date as sent by the hub. */
  acceptedDate?: string | null;
  isCurrent?: boolean | null;
  /** ISO timestamp as sent by the hub. */
  syncedAt?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.chemicalId = nullableString(source['chemicalId']);
    this.labelUrl = nullableString(source['labelUrl']);
    this.labelName = nullableString(source['labelName']);
    this.acceptedDate = nullableString(source['acceptedDate']);
    this.isCurrent = nullableBoolean(source['isCurrent']);
    this.syncedAt = nullableString(source['syncedAt']);
  }
}

